import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  VERIFY_COGNITO_USER,
  CREATE_COGNITO_USER,
  SIGN_IN_COGNITO_USER
} from "constants/ActionTypes";
import { PUT_COGNITO_USER, INIT_COGNITO_AUTH_SESSION, ACCEPT_OTP, SIGNUP_COGNIO_USER_SUCCESS, SIGN_IN_COGNITO_USER_SUCCESS, VERIFY_COGNITO_OTP, RESET_AUTH_STORE, SHOW_AUTH_MESSAGE } from "../../constants/ActionTypes";

export const userSignUp = (user) => {
  return {
    type: SIGNUP_USER,
    payload: user
  };
};
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};
export const userSignOut = () => {
  return {
    type: SIGNOUT_USER
  };
};
export const userSignUpSuccess = (authUser) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: authUser
  };
};
export const createCognitoUser = (user) => {
  return {
    type: CREATE_COGNITO_USER,
    payload: user
  };
};
export const verifyUserPhoneNumber = (singedUpUser) => {
  return {
    type: VERIFY_COGNITO_USER,
    payload: singedUpUser
  };
};
export const signInCognitoUser = (user) => {
  return {
    type: SIGN_IN_COGNITO_USER,
    sign_in_progress:true,
    payload: user
  };
};
export const putCognitoUser = (user) => {
  return {
    type: PUT_COGNITO_USER,
    payload: user
  };
};
export const verifyCognitoOtp = (user) => {
  return {
    type: VERIFY_COGNITO_OTP,
    payload: user
  };
};

export const signInCognitoUserSuccess = (user) => {
  return {
    type: SIGN_IN_COGNITO_USER_SUCCESS,
    payload: user
  };
};

export const signUpCognitoUserSuccess = (user) => {
  return {
    type: SIGNUP_COGNIO_USER_SUCCESS,
    payload: user
  };
}
export const acceptOTP = () => {
  return {
    type: ACCEPT_OTP,
    payload: null
  };
};

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    payload: message
  };
};
export const initCognitoAuthSession = (authUser) => {
  return {
    type: INIT_COGNITO_AUTH_SESSION,
    payload:authUser
  };
};

export const resetAuthStore = ()=>{
  return {
    type: RESET_AUTH_STORE,
  };
  
}

export const userGoogleSignIn = () => {
  return {
    type: SIGNIN_GOOGLE_USER
  };
};
export const userGoogleSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GOOGLE_USER_SUCCESS,
    payload: authUser
  };
};
export const userFacebookSignIn = () => {
  return {
    type: SIGNIN_FACEBOOK_USER
  };
};
export const userFacebookSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_FACEBOOK_USER_SUCCESS,
    payload: authUser
  };
};
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};
export const userTwitterSignIn = () => {
  return {
    type: SIGNIN_TWITTER_USER
  };
};
export const userTwitterSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_TWITTER_USER_SUCCESS,
    payload: authUser
  };
};
export const userGithubSignIn = () => {
  return {
    type: SIGNIN_GITHUB_USER
  };
};
export const userGithubSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GITHUB_USER_SUCCESS,
    payload: authUser
  };
};
export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
